const SECONDS = 1000;
const MINUTES = 60 * SECONDS;

// Poller config
export const config = {
  NOTIFICATIONS_POLL_INTERVAL: 1 * MINUTES,
  NOTIFICATIONS_MAX_STALE_TIME: 5 * SECONDS,

  ROOM_THREADS_POLL_INTERVAL: 5 * MINUTES,
  ROOM_THREADS_MAX_STALE_TIME: 5 * SECONDS,

  USER_THREADS_POLL_INTERVAL: 1 * MINUTES,
  USER_THREADS_MAX_STALE_TIME: 5 * SECONDS,

  HISTORY_VERSIONS_POLL_INTERVAL: 1 * MINUTES,
  HISTORY_VERSIONS_MAX_STALE_TIME: 5 * SECONDS,

  NOTIFICATION_SETTINGS_POLL_INTERVAL: 1 * MINUTES,
  NOTIFICATION_SETTINGS_MAX_STALE_TIME: 5 * SECONDS,
};
